export class ExpiredState {
  constructor (data, expiredTime = 7200) {
    this._data = data
    this.expiredTime = expiredTime
    this.lastTime = this._updateLastTime()
  }

  _updateLastTime () {
    let curDate = new Date().getTime()
    return curDate + this.expiredTime * 1000
  }

  isExpired () {
    let curDate = new Date().getTime()
    return curDate > this.lastTime
  }

  isValid () {
    return this._data && !this.isExpired()
  }

  set data (value) {
    this._data = value
    this.lastTime = this._updateLastTime()
  }

  get data() {
    return this._data
  }
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/expiredState.js